import { useEffect, useRef } from 'react';
import { useAnalytics } from '../../../hooks/use-analytics';
import { GxpCustomUIParams } from '../../../views/gxp-customui-view/gxp-customui-params';
interface Props {
    gxpUIParams: GxpCustomUIParams;
}
export const GxpCustomUI = (props: Props) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const serviceCXUrl = process.env.REACT_APP_CUSTOM_UI_URL;
    const [fireEvents] = useAnalytics();
    const triggerGuestXPLoadAnalytics = () => {
        fireEvents(['guest-xp'], 'guest-xp', undefined, false);
    };
    useEffect(() => {
        if (serviceCXUrl) {
            triggerGuestXPLoadAnalytics();
        }
        const handleMessage = (e: MessageEvent) => {
            const eventName = e.data[0];
            const data = e.data[1];

            switch (eventName) {
                case 'setHeight':
                    if (iframeRef.current) {
                        iframeRef.current.style.height = `${data}px`;
                    }
                    break;
            }
        };

        window.addEventListener('message', handleMessage);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <>
            <iframe
                id="GXP-iframe"
                ref={iframeRef}
                width="100%"
                src={`${serviceCXUrl}?dealerCode=${props.gxpUIParams.dealerCode}&channelType=${props.gxpUIParams.channelType}&isAuth=${props.gxpUIParams.isAuth}`}
                style={{
                    border: 'none',
                    overflow: 'hidden',
                    height: '1275px',
                }}
            ></iframe>
        </>
    );
};
